<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12" lg="4" md="4">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.userSimulator.pageHeader')
        }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row class="page-tab">
      <v-col class="pt-0" cols="12">
        <v-row no-gutters class="scanner-section">
          <v-col cols="12" lg="6" md="6" class="pl-0 pb-0 pt-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-mapper-file" style="height: 750px">
                <v-row class="v-grid-title row-pd mb-4">
                  <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="3">
                    <div class="pl-0 pt-0 pb-0">
                      <span class="scanner-label">{{ $t('lbl.userSimulator.title') }}</span>
                    </div>
                  </v-col>
                  <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="9">
                    <div class="btn-form-control mb-0 d-inline-flex">
                      <v-menu open-on-hover offset-y>
                        <template v-slot:activator="{ on, attrs, value }">
                          <v-btn class="btn-active btn-browser btn-inline" v-bind="attrs" v-on="on">
                            Load
                            <v-icon :class="value ? 'fa-rotate-180' : ''">
                              mdi mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list class="map-builder-custom-list">
                          <v-list-item
                            v-for="(item, index) in loadTypes"
                            :key="index"
                            @click="changeLoadType(item)"
                          >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <input
                        @change="inputScriptFileLocal"
                        id="script_data"
                        type="file"
                        ref="script_data"
                        style="display: none"
                        accept=".js"
                      />
                      <v-btn
                        @click="openScriptListDialog"
                        class="btn-active btn-scanner btn-inline"
                      >
                        <v-icon x-small class="mr-1 show-load-icon">fa fa-list</v-icon>
                        <span class="show-load-txt">{{ $t('btn.userSimulator.scriptList') }}</span>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters class="scanner-icon">
                  <v-col class="pa-0" cols="12" lg="7" md="6">
                    <div class="mapper-file-name" v-if="this.scriptFileName != ''">
                      {{ this.scriptFileName }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right" cols="12" lg="5" md="6">
                    <v-menu
                      offset-x
                      :close-on-content-click="false"
                      transition="scale-transition"
                      origin="left"
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          x-small
                          text
                          icon
                          class="mr-1 ml-1"
                          v-bind="attrs"
                          v-on="on"
                          style="margin-bottom: 2px"
                        >
                          <icon-svg iconName="clear" />
                        </v-btn>
                      </template>
                      <v-list dense class="text-xs custom-menu">
                        <v-list-item @click="clearView('script')">
                          <v-list-item-content>
                            <v-list-item-title>{{ $t('btn.mapBuilder.clear') }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="clearTab()">
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t('btn.mapBuilder.clearAll')
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn class="btn-expand" x-small text icon @click="expandView('script')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-view-scanner">
                  <div class="CodeMirror">
                    <ScriptViewer
                      v-model="scriptFileContent"
                      :options="this.cmOption"
                      @changes="onChangeTextView('script')"
                      ref="scriptFile"
                    ></ScriptViewer>
                  </div>
                </v-row>
                <v-row class="btn-form-control mb-4">
                  <v-col class="data-query-section pb-0 pt-0 pl-0 mt-0" cols="12" lg="6" md="6">
                    <div class="pl-0 pt-0 pb-0 mr-0">
                      <v-btn
                        @click="saveScriptFile"
                        :disabled="isValidScript"
                        class="btn-active btn-execute"
                      >
                        {{ $t('btn.dbMapperTest.xmlMapper.save') }}
                      </v-btn>
                      <v-btn
                        @click="openLoadFilePop({ mode: 'Save', filetype: 'script' })"
                        :disabled="isValidScript"
                        class="btn-active btn-search mt-0 mb-0"
                      >
                        {{ $t('btn.dbMapperTest.xmlMapper.saveA') }}
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col
                    class="data-query-section pb-0 pt-0 mt-0 text-right"
                    cols="12"
                    lg="6"
                    md="6"
                  >
                    <div class="pl-0 pt-0 pb-0 mr-0">
                      <v-btn
                        class="btn-active btn-execute"
                        @click="validateJS"
                        :disabled="isValidScript"
                      >
                        {{ $t('btn.userSimulator.validation') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters class="scanner-icon pb-4">
                  <v-col class="pa-0" cols="12" lg="10" md="10">
                    <div class="file-name">
                      <span class="scanner-label">{{
                        $t('lbl.dbMapperTest.xmlMapper.resultTest')
                      }}</span>
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="expandView('resultTest')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="build-test-result">
                  <div class="CodeMirror">
                    <ResultTestViewer
                      :value="this.resultTestField"
                      :options="this.buildCmOption"
                      ref="resultTest"
                    ></ResultTestViewer>
                  </div>
                </v-row>
                <v-row v-if="$auth.manage" class="btn-grid no-gutters btn-form-control mt-1">
                  <v-col cols="12" lg="12" md="12" class="pa-0 text-right">
                    <v-btn
                      @click="testScript"
                      :disabled="isValidScriptOK"
                      class="btn-active btn-search mt-0 mb-0"
                    >
                      {{ $t('btn.dbMapperTest.xmlMapper.test') }}
                    </v-btn>
                    <v-btn
                      class="btn-active btn-search"
                      :disabled="isTestedOK"
                      @click="openDeployUserComp"
                      >{{ $t('btn.userSimulator.deploy') }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" lg="6" md="12" class="pl-0 pb-0 pt-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-right-data" style="height: 750px">
                <v-row no-gutters class="request-param">
                  <v-col class="pa-0 mt-0 mb-3" cols="12" lg="12" md="12">
                    <fieldset class="pl-3">
                      <legend class="scanner-label pl-3 pr-3">Request Parameter</legend>
                      <v-tooltip top disabled>
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="btn-tooltip">
                            <v-col lg="1" class="pa-0 mb-1 text-right">
                              <v-icon dense @click="addParam()">
                                mdi-plus
                              </v-icon>
                            </v-col>
                          </div>
                        </template>
                        <span v-html="$t('lbl.communications.validMaxPattern')"></span>
                      </v-tooltip>
                      <v-form
                        ref="formRequestParams"
                        lazy-validation
                        style="height: 110px; overflow: auto"
                        v-on:submit.prevent="doNoThing"
                      >
                        <v-row
                          class="ml-0 mr-0 mb-4 edi-identification"
                          v-for="(item, index) in requestParams"
                          :key="item.id"
                        >
                          <v-col cols="12" md="4" class="pa-0">
                            <v-tooltip top :disabled="!item.isValidateParam">
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <v-text-field
                                    :ref="'RP_' + item.id"
                                    solo
                                    hide-details
                                    v-model="item.keyPattern"
                                    @change="validateParam(item)"
                                    :rules="[validationUtils.required]"
                                  ></v-text-field>
                                </div>
                              </template>
                              <span v-html="$t('lbl.userSimulator.validDuplicateParam')"></span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="12" md="7" class="pa-0 pl-2">
                            <v-text-field
                              :ref="'RP_' + item.id + '_' + item.id"
                              solo
                              hide-details
                              v-model="item.valuePattern"
                              :rules="[validationUtils.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="1" class="pa-0 mt-2 text-center">
                            <v-icon dense @click="removeParam(index)">
                              mdi-minus
                            </v-icon>
                          </v-col>
                        </v-row>
                      </v-form>
                    </fieldset>
                  </v-col>
                </v-row>
                <v-row class="v-grid-title row-pd mb-4">
                  <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="3">
                    <div class="pl-0 pt-0 pb-0">
                      <span class="scanner-label">{{ $t('lbl.userSimulator.input') }}</span>
                    </div>
                  </v-col>
                  <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="9">
                    <div class="btn-form-control mb-0">
                      <v-menu open-on-hover offset-y>
                        <template v-slot:activator="{ on, attrs, value }">
                          <v-btn
                            class="btn-active btn-browser btn-inline mr-0"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Load
                            <v-icon :class="value ? 'fa-rotate-180' : ''">
                              mdi mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list class="map-builder-custom-list">
                          <v-list-item
                            v-for="(item, index) in loadTypes"
                            :key="index"
                            @click="changeLoadInputType(item)"
                          >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <input
                        @change="inputInputFileLocal"
                        id="input_data"
                        type="file"
                        ref="input_data"
                        style="display: none"
                        accept=".txt"
                      />
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters class="scanner-icon">
                  <v-col class="pa-0" cols="12" lg="10" md="10">
                    <div class="file-name" v-if="this.inputFileName != ''">
                      {{ this.inputFileName }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="clearView('input')" class="mr-1">
                      <icon-svg iconName="clear" />
                    </v-btn>
                    <v-btn x-small text icon @click="expandView('input')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-view-in">
                  <div class="CodeMirror">
                    <InputViewer
                      v-model="inputFileContent"
                      :options="this.cmOption"
                      @changes="onChangeTextView('input')"
                      ref="input"
                    ></InputViewer>
                  </div>
                </v-row>
                <v-row class="btn-grid no-gutters btn-form-control mt-1">
                  <v-col class="pa-0 pr-3 text-left" cols="12" lg="12" md="12">
                    <div class="pl-0 pt-0 pb-0 mr-0">
                      <v-btn
                        :disabled="isValidInput"
                        @click="saveInputFile"
                        class="btn-active btn-execute"
                      >
                        {{ $t('btn.dbMapperTest.xmlMapper.save') }}
                      </v-btn>
                      <v-btn
                        @click="openLoadFilePop({ mode: 'Save', filetype: 'input' })"
                        :disabled="isValidInput"
                        class="btn-active btn-search mt-0 mb-0"
                      >
                        {{ $t('btn.dbMapperTest.xmlMapper.saveA') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="v-grid-title row-pd mb-4 mt-5">
                  <v-col class="date-query-section pa-0 mt-0" cols="12" lg="10" md="10">
                    <div class="pl-0 pt-0 pb-0">
                      <span class="scanner-label">{{ $t('lbl.userSimulator.output') }}</span>
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="expandView('output')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-output-data">
                  <div class="CodeMirror" id="testMapper">
                    <OutputDataViewer
                      v-model="outputFileContent"
                      :options="buildCmOption"
                      ref="outputFile"
                    ></OutputDataViewer>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <scriptList
        v-if="dialog.type == 'scriptList'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openUserCompVersion="openUserCompVersion($event)"
        class="maplist-layout-dialog"
        ref="scriptList"
      >
      </scriptList>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        @openDeployUserComp="openDeployUserComp($event)"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
      ></versionHistory>
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="load-file-dialog"
      >
      </load-file-dialog>
      <deployUserComp
        v-if="dialog.type == 'deployUserComp'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openLoadFile="openLoadFile($event)"
        class="custom-dialog mapper-version"
        ref="deployUserComp"
      >
      </deployUserComp>
    </div>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      @select-ok="removeDialog"
      :detail="$t('msg.dbMapperManager.deployMapper.deploySuccess')"
    ></dialogWindow>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="$t('msg.userSimulator.validDuplicate')"
      color="warning"
      @select-ok="removeDialog"
    >
    </dialogWindow>
  </div>
</template>

<script>
import IconSvg from '@/vue-caas/components/IconBase.vue';
import ScriptViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import InputViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import ResultTestViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import OutputDataViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import scriptList from '@/vue-caas/views/usercomp/ScriptListDialog.vue';
import versionHistory from '@/vue-caas/views/usercomp/UserComponentVersionHistory.vue';
import loadFileDialog from '@/vue-caas/views/usercomp/LoadFile.vue';
import deployUserComp from '@/vue-caas/views/usercomp/DeployUserComp.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

import $ from 'jquery';

export default {
  components: {
    IconSvg,
    ScriptViewer,
    InputViewer,
    ResultTestViewer,
    OutputDataViewer,
    scriptList,
    versionHistory,
    loadFileDialog,
    deployUserComp,
    dialogWindow,
  },
  data() {
    return {
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      scriptFileContent: '',
      scriptFileID: '',
      scriptFileName: '',
      scriptFileNameSave: '',
      scriptFileSize: 0,
      scriptFile: '',
      scriptFileExtension: '',
      scriptFolderId: '',
      scriptFileStatus: '',
      lastFoldIdInput: '',
      lastFoldIdScript: '',
      inputFileContent: '',
      inputFileName: '',
      inputFileID: '',
      inputFileNameSave: '',
      inputFileSize: 0,
      inputFileExtension: '',
      inputFile: '',
      inputFolderId: '',
      inputFileStatus: '',
      outputFileContent: '',
      isSaved: false,
      resultTest: {},
      resultValid: {},
      resultTestField: '',
      moveData: {},
      requestParams: [],
      setPattern: new Set(),
      isDuplicateParam: false,
      loadTypes: [
        { text: 'Load From Local', value: 'local' },
        { text: 'Load From Server', value: 'server' },
      ],
    };
  },
  computed: {
    isTestedOK() {
      if (this.resultTest.result == undefined) return true;
      if (this.resultTest.result.check === 'OK') return false;
      return true;
    },
    isValidScriptOK() {
      if (this.resultValid.result == undefined) return true;
      if (this.resultValid.result.status === 'VALID') return false;
      return true;
    },
    isValidScript() {
      if (this.scriptFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidInput() {
      if (this.inputFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    cmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          readOnly: false,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: false,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    buildCmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: false,
          line: false,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: false,
        line: false,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
  },
  methods: {
    resetSetPattern() {
      this.setPattern.clear();
      this.requestParams.map((item) => {
        if (item.keyPattern !== '') {
          this.setPattern.add(item.keyPattern);
        }
      });
    },
    removeParam(index) {
      this.requestParams.splice(index, 1);
      this.resetSetPattern();
    },
    validateParam(itemChange) {
      let indexValid = this.requestParams.findIndex((e) => e.id === itemChange.id);
      if (this.setPattern.has(itemChange.keyPattern)) {
        this.isDuplicateParam = true;
        this.requestParams[indexValid].isValidateParam = true;
      } else {
        this.isDuplicateParam = false;
        this.requestParams[indexValid].isValidateParam = false;
      }
      this.resetSetPattern();
    },
    doNoThing() {
      console.log('Skip Enter');
    },
    addParam() {
      let index =
        this.requestParams.length > 0
          ? this.requestParams[this.requestParams.length - 1].id + 1
          : 1;
      this.requestParams.push({
        id: index,
        keyPattern: '',
        valuePattern: '',
        isValidateParam: false,
      });
    },
    validateJS() {
      Store.dispatch('validateJS', { content: this.scriptFileContent }).then(() => {
        this.resultValid = this.$store.getters.resultUserCompValidate;
        if (this.resultValid.result.status === 'INVALID') {
          const line =
            this.scriptFileContent
              .split('\n')
              .findIndex((e) => e == this.resultValid.result.detail) + 1;
          this.resultValid.result.detail = 'Line ' + line + ': ' + this.resultValid.result.detail;
        }
        this.resultTestField =
          this.resultValid.result.status +
          '\n' +
          this.resultValid.result.message +
          '\n' +
          this.resultValid.result.detail;
      });
    },
    openUserCompVersion(itemRow) {
      let type = 'versionHistory';
      let item = {
        ROWID: 0,
        data: itemRow,
        action: 'usercompsim',
      };
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openDeployUserComp(itemRow) {
      let type = 'deployUserComp';
      let item = {
        ROWID: 0,
        action: 'usercompsim',
        data: this.getParamsDeploy(),
      };
      let indexArrDialog = this.findDialog('deployUserComp_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    getRequestParamArray(listObject) {
      let paramArray = [];
      if (listObject.length > 0) {
        listObject.forEach((item) => {
          let param;
          param = { [item.keyPattern]: item.valuePattern };
          paramArray.push(param);
        });
      } else {
        paramArray = [];
      }
      return paramArray;
    },
    getParamsTest() {
      let params = {
        FILE_ID: this.scriptFileID,
        FILE_NAME: this.scriptFileName,
        FILE_TYPE: this.scriptFileExtension,
        FILE_CONTENT: this.scriptFileContent,
        jsonFileContent: this.inputFileContent,
        reqParams: this.getRequestParamArray(this.requestParams),
      };
      return params;
    },
    getParamsDeploy() {
      let params = {
        uc_id: this.moveData.uc_id,
        uc_name: this.moveData.uc_name,
        file_id: this.scriptFileID,
        file_name: this.scriptFileName,
        file_type: this.scriptFileExtension,
        file_content: this.scriptFileContent,
        uc_file_id: this.moveData.uc_file_id,
      };
      return params;
    },
    testScript() {
      if (this.isDuplicateParam) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        return -1;
      }
      let index = this.requestParams.findIndex((e) => e.keyPattern === '' || e.valuePattern === '');
      if (index > -1) {
        let itemPattern = this.requestParams[index];
        this.$refs[
          `RP_${itemPattern.id}${itemPattern.keyPattern === '' ? '' : '_' + itemPattern.id}`
        ][0].focus();
        return -1;
      }
      console.log('------- TEST SCRIPT ---------');
      this.resultTest = 'Processing...';
      this.outputFileContent = '';
      let params = this.getParamsTest();
      this.$store.dispatch('testUserCompSimulator', params).then(() => {
        this.resultTest = this.$store.getters.resultUserCompTest;
        this.resultTestField = this.resultTest.result.status + '\n' + this.resultTest.result.detail;
        let outputFileContentList = this.resultTest.files;
        for (let i = 0; i < outputFileContentList.length; i++) {
          this.outputFileContent += outputFileContentList[i];
          this.outputFileContent += '\n';
        }
        params.FILE_STATUS = this.resultTest.result.check == 'OK' ? 'Passed' : 'Failed';
        Store.dispatch('updateXmlMapBuiderFile', params);
      });
    },
    saveScriptFile() {
      if (this.scriptFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'script' });
        return;
      }
      else {
        if (this.scriptFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Script Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.scriptFolderId;
          savefile.FILE_ID = this.scriptFileID;
          savefile.FILE_NAME = this.scriptFileName;
          savefile.USR_FILE_SIZE = new Blob([this.scriptFileContent]).size;
          savefile.FILE_TYPE = this.scriptFileExtension;
          savefile.file = this.scriptFileContent;
          savefile.FILE_CONTENT = this.scriptFileContent;
          savefile.USR_FILE_KIND = 'SCRIPT';
          savefile.FILE_STATUS = 'Saved';
          console.log('this is update----------->');
          Store.dispatch('updateXmlMapBuiderFile', savefile).then(() => {
            this.isSaved = true;
          });
        }
      }
    },
    saveInputFile(mode) {
      console.log('-------SaveNewInputFile--------');
      if (this.inputFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'input' });
        return;
      }
      else {
        if (this.inputFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Input Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.inputFolderId;
          savefile.FILE_ID = this.inputFileID;
          savefile.FILE_NAME = this.inputFileName;
          savefile.USR_FILE_SIZE = new Blob([this.inputFileContent]).size;
          savefile.FILE_TYPE = this.inputFileExtension;
          savefile.file = this.inputFileContent;
          savefile.FILE_CONTENT = this.inputFileContent;
          savefile.USR_FILE_KIND = 'IN';
          savefile.FILE_STATUS = this.inputFileStatus;
          console.log('this is update----------->');
          Store.dispatch('updateXmlMapBuiderFile', savefile).then(() => {
            this.isSaved = true;
          });
        }
      }
    },
    onChangeTextView(type) {
      if (type === 'input') {
        this.$refs.input_data.value = null;
      } else if (type === 'script') {
        this.$refs.script_data.value = null;
      }
    },
    expandView(type) {
      if (type == 'input') {
        this.$refs.input.cminstance.setOption('fullScreen', true);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Input',
          iconClass: ' icon-collapse-json',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'right-add-row' });
        $('.zoom-right-data .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-json').on('click', { type: 'input' }, this.closeExpand);
      } else if (type === 'script') {
        this.$refs.scriptFile.cminstance.setOption('fullScreen', true);
        //Close another view
        this.$refs.input.cminstance.setOption('fullScreen', false);
        this.$refs.outputFile.cminstance.setOption('fullScreen', false);

        $('.right-add-row').remove();
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Script File',
          iconClass: 'icon-collapse-mapper',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'mapper-add-row' });
        $('.zoom-mapper-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-mapper').on('click', { type: 'script' }, this.closeExpand);
      } else if (type === 'output') {
        this.$refs.outputFile.cminstance.setOption('fullScreen', true);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Output File',
          iconClass: 'icon-collapse-output',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'right-add-row' });
        $('.zoom-right-data .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-output').on('click', { type: 'output' }, this.closeExpand);
      } else if (type === 'resultTest') {
        this.$refs.resultTest.cminstance.setOption('fullScreen', true);
        this.$refs.input.cminstance.setOption('fullScreen', false);
        this.$refs.outputFile.cminstance.setOption('fullScreen', false);
        $('.right-add-row').remove();
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Result of test',
          iconClass: 'icon-build-result',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'mapper-add-row' });
        $('.zoom-mapper-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-build-result').on('click', { type: 'test' }, this.closeExpand);
      }
    },
    closeExpand(e) {
      if (e.data.type == 'input') {
        $('.right-add-row').remove();
        this.$refs.input.cminstance.setOption('fullScreen', false);
      } else if (e.data.type == 'script' || e.data.type == 'test') {
        $('.mapper-add-row').remove();
        // $('.build-add-row').remove();
        this.$refs.scriptFile.cminstance.setOption('fullScreen', false);
        this.$refs.resultTest.cminstance.setOption('fullScreen', false);
      } else if (e.data.type == 'output') {
        $('.right-add-row').remove();
        this.$refs.outputFile.cminstance.setOption('fullScreen', false);
      }
    },
    clearTab() {
      this.clearView('script');
      this.clearView('input');
    },
    clearView(type) {
      if (type === 'script') {
        this.scriptFileName = '';
        this.scriptFileContent = '';
        this.scriptFileID = '';
        this.scriptFileNameSave = '';
        this.scriptFileSize = '';
        this.scriptFileExtension = '';
        this.scriptFolderId = '';
        this.scriptFileStatus = '';
      } else if (type === 'input') {
        this.inputFileName = '';
        this.inputFileContent = '';
        this.inputFileID = '';
        this.inputFolderId = '';
        this.inputFileNameSave = '';
        this.inputFileStatus = '';
      }
    },
    loadInputLocal() {
      this.$refs.input_data.click();
    },
    inputInputFileLocal(e) {
      this.inputFileName = '';
      this.inputFileID = '';
      this.inputFileNameSave = e.target.files[0].name;
      this.inputFileExtension = e.target.files[0].name.split('.').pop();
      this.inputFile = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.inputFileContent = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    changeLoadInputType(type) {
      if (type.value === 'local') {
        this.loadInputLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'input' });
      }
    },
    changeLoadType(type) {
      if (type.value === 'local') {
        this.loadScriptLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'script' });
      }
    },
    loadScriptLocal() {
      this.$refs.script_data.click();
    },
    inputScriptFileLocal(e) {
      this.scriptFileName = '';
      this.scriptFileID = '';
      this.scriptFileNameSave = e.target.files[0].name;
      this.scriptFileExtension = e.target.files[0].name.split('.').pop();
      this.scriptFileSize = e.target.files[0].size;
      this.scriptFile = e.target.files[0];
      
      this.scriptrFileID = '';
      this.resultField = '';
      this.isSaved = false;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.scriptFileContent = reader.result;
       };
      reader.readAsText(e.target.files[0]);
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      if (mode == 'Load') {
        let callback = (row) => {
          Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {
            if (filetype == 'input') {
              this.$refs.input_data.value = null;
              let row = this.$store.getters.viewFileData[0];
              this.inputFileContent = row.FILE_CONTENT;
              this.inputFileID = row.FILE_ID;
              this.inputFileName = row.FILE_NAME;
              this.inputFileNameSave = row.FILE_NAME;
              this.inputFileSize = row.USR_FILE_SIZE;
              this.inputFileExtension = row.FILE_TYPE;
              this.inputFolderId = row.FOLD_ID;
              this.lastFoldIdInput = row.FOLD_ID;
              this.inputFileStatus = row.FILE_STATUS;
            } else if (filetype == 'script') {
              this.$refs.script_data.value = null;
              let row = this.$store.getters.viewFileData[0];
              this.scriptFileContent = row.FILE_CONTENT;
              this.scriptFileID = row.FILE_ID;
              this.scriptFileName = row.FILE_NAME;
              this.scriptFileNameSave = row.FILE_NAME;
              this.scriptFileSize = row.USR_FILE_SIZE;
              this.scriptFileExtension = row.FILE_TYPE;
              this.scriptFolderId = row.FOLD_ID;
              this.isSaved = true;
              this.lastFoldIdScript = row.FOLD_ID;
              this.scriptFileStatus = row.FILE_STATUS;
            }
          });
        };
        this.openLoadFile({
          mode: 'Load',
          filetype: filetype,
          lastFoldIdInput: this.lastFoldIdInput,
          lastFoldIdScript: this.lastFoldIdScript,
          callback,
        });
      }
      if (mode == 'Save') {
        let callback = (row) => {
          if (filetype == 'input') {
            this.inputFileName = row.FILE_NAME;
            this.inputFileNameSave = row.FILE_NAME;
            this.$refs.input_data.value = null;
            this.inputFileContent = row.file;
            this.inputFileID = row.FILE_ID;
            this.inputFileSize = row.FILE_SIZE;
            this.inputFileExtension = row.FILE_TYPE;
            this.inputFolderId = row.FOLD_ID;
            this.lastFoldIdInput = row.FOLD_ID;
          } else if (filetype == 'script') {
            this.$refs.script_data.value = null;
            this.scriptFileContent = row.file;
            this.scriptFileID = row.FILE_ID;
            this.scriptFileName = row.FILE_NAME;
            this.scriptFileNameSave = row.FILE_NAME;
            this.scriptFileSize = row.USR_FILE_SIZE;
            this.scriptFileExtension = row.FILE_TYPE;
            this.scriptFolderId = row.FOLD_ID;
            this.lastFoldIdScript = row.FOLD_ID;
            this.isSaved = true;
          }
        };
        let content = [];
        if (filetype == 'input') {
          content.push(this.inputFileContent);
          if (this.inputFileExtension == '') {
            this.inputFileExtension = 'txt';
          }
          content.push(this.inputFileExtension);
          content.push(this.inputFileNameSave);
          content.push('IN');
        } else if (filetype == 'script') {
          content.push(this.scriptFileContent);
          if (this.scriptFileExtension == '') {
            this.scriptFileExtension = 'js';
          }
          content.push(this.scriptFileExtension);
          content.push(this.scriptFileNameSave);
          content.push('SCRIPT');
        }
        this.openLoadFile({
          mode: 'Save',
          filetype: filetype,
          content,
          lastFoldIdInput: this.lastFoldIdInput,
          lastFoldIdScript: this.lastFoldIdScript,
          callback,
        });
      }
    },
    openLoadFile(data) {
      this.prs = {
        CUST_ID: 'cyberlogitec.com',
        STR_SNDR: 'NDAL',
        STR_RCVR: 'CTCT',
        MSG_ID: 'COPARN',
        MSG_VER: 'UND95B',
        DAT_TYPE: 'UPDT',
        FR_DAT: '20200615',
        TO_DAT: '20200715',
        MSG_CNT: null,
        FFL_FILE_NAME: null,
        MAP_NAME: 'test_add_file_modify',
        MAP_CONV_TP: 'F2E',
        FFL_FRMT_TP: null,
        PRCS_STS: 'REPO',
        LAY_PRCS_NO: 'R000000152',
        SRM_PRCS_NO: 'REP0000085',
        ALIAS: '',
        ROWID: 29,
      };
      let type = 'loadFile';
      let item = {
        ROWID: 0,
        data,
      };
      let indexArrDialog = this.findDialog('loadFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openScriptListDialog(selectItem) {
      let type = 'scriptList';
      let item = {
        ROWID: 0,
        item: selectItem,
      };
      let indexArrDialog = this.findDialog('scriptList_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
  },
  created() {
    const query = this.$route.query;
    if (this.$route.query.userCompId) {
      this.$store
        .dispatch('getUserCompMoveData', { userCompId: query.userCompId, ver: query.ver })
        .then(() => {
          this.moveData = this.$store.getters.userCompMoveData;
          console.log('moveData', this.moveData);
          this.scriptFileID = this.moveData.file_id;
          this.scriptFileStatus = this.moveData.file_status;
          this.scriptFileExtension = this.moveData.file_type;
          this.scriptFolderId = this.moveData.fold_id;
          this.scriptFileContent = this.moveData.file_content;
          this.scriptFileName = this.moveData.file_name;
          this.scriptFileNameSave = this.moveData.file_name;
        });
    }
  },
};
</script>

<style>
.build-test-result .CodeMirror {
  height: 175px !important;
}
.text-view-in .CodeMirror {
  height: 140px !important;
}
.text-output-data .CodeMirror {
  height: 153px !important;
}
</style>
